<page-toolbar [pageActions]="pageActions" title="ExternalTokens"></page-toolbar>

<page-content>
  <data-table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" title="Externe Login Tokens"
                  [dataProviderParams]="dataProviderParams" [dataProvider]="externalTokenService" [searchAll]="true">
  </data-table>
</page-content>
